import {
  useMutation,
  useQuery,
  type UseMutationResult,
  type UseQueryResult,
} from '@tanstack/react-query'

import { checkPolicyAcceptance } from 'src/app/auth/adapters/terms-acceptance/check-policy-acceptance.adapter'
import {
  persistTermsAcceptance,
  POLICY_API_VERSION,
} from 'src/app/auth/adapters/terms-acceptance/persist-terms-acceptance'

import { authKeys } from './keys'

export interface IUsePolicyAcceptanceQueryParams {
  enabled: boolean
}

export const usePolicyAcceptanceQuery = (
  params: IUsePolicyAcceptanceQueryParams,
): UseQueryResult<{ accepted: boolean }, Error> =>
  useQuery({
    queryKey: authKeys.policyAcceptance(POLICY_API_VERSION),
    queryFn: checkPolicyAcceptance,
    enabled: params.enabled,
    retry: false,
    staleTime: Infinity,
    meta: { silent: true },
  })

export const usePolicyAcceptanceMutation = (): UseMutationResult<
  void,
  Error,
  void
> =>
  useMutation({
    mutationKey: authKeys.policyAcceptance(POLICY_API_VERSION),
    mutationFn: persistTermsAcceptance,
  })
